import {createSlice} from "@reduxjs/toolkit";
import lessonsProgramSlice from "./LessonsProgramSlice";

const ScheduleSlice = createSlice({
    name: "schedule",
    initialState: [
    ],
    reducers: {
        update: (state, action) => {
            return [...action.payload]
        }
    }
})

export default ScheduleSlice.reducer;
export const {update: updateSchdeule} = ScheduleSlice.actions;